import React from "react";
import { useNavigate } from "react-router-dom";
import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Servicio = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f7f7f7" }}>
      {/* AppBar */}
      <AppBar position="sticky" style={{ backgroundColor: "#59005B" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontFamily: "'Poppin', 'Helvetica', 'Arial', sans-serif",
              letterSpacing: 4,
            }}
          >
            ¿CÓMO RECIBISTE EL SERVICIO?
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Contenido principal */}
     <div
  style={{
    paddingBottom: "80px", // Espacio para la BottomAppBar si tienes una
    height: "calc(100vh - 64px)", // Altura completa menos el AppBar (64px es lo usual)
    overflow: "hidden",
  }}
>
  <iframe
    title="Formulario de Servicio"
    src="https://forms.gle/wiVnXkDPXEQgYnPc8"
    width="100%"
    height="100%"
    frameBorder="0"
    style={{ border: "none" }}
    allowFullScreen
  >
    Cargando…
  </iframe>
</div>

    </div>
  );
};

export default Servicio;
